import axios from 'axios';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { contentCategoriesUrl } from '../../configurations/api/url';
import { SentryCapture } from '../../analytics/Sentry';
import type { IContentCategory } from '../../utils/contentCategoriesApi';
import {
    buildCatalogFromCategories,
    fallbackContentCategoryCatalog,
    getRawContentCategoriesCache,
    setContentCategoriesCache,
} from '../../utils/contentCategoriesApi';
import { settle } from '../sandbox/sagaHelpers';
import { fetchContentCategories, fetchContentCategoriesSuccess } from './actions';
import type { RootState } from '../root-reducer';

function* fetchContentCategoriesSaga({ payload, resolve, reject }: any): Generator<any, void, any> {
    const force = payload?.force;
    const cached = getRawContentCategoriesCache();
    if (cached && !force) {
        yield put(fetchContentCategoriesSuccess(cached));
        settle(resolve, reject, cached);
        return;
    }

    try {
        const token: string | null = yield select((s: RootState) => s.authentication.token);
        const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
        const res = yield call(axios.get, contentCategoriesUrl, { headers });
        const rows = (res.data?.data?.categories || []) as IContentCategory[];
        let catalog;
        if (!Array.isArray(rows) || rows.length === 0) {
            catalog = fallbackContentCategoryCatalog();
        } else {
            catalog = buildCatalogFromCategories(rows, 'api');
        }
        setContentCategoriesCache(catalog);
        yield put(fetchContentCategoriesSuccess(catalog));
        settle(resolve, reject, catalog);
    } catch (error: any) {
        SentryCapture(error, 'error');
        const catalog = fallbackContentCategoryCatalog();
        setContentCategoriesCache(catalog);
        yield put(fetchContentCategoriesSuccess(catalog));
        settle(resolve, reject, catalog);
    }
}

export default function* contentCategoriesSaga() {
    yield all([takeLatest(fetchContentCategories as any, fetchContentCategoriesSaga)]);
}
